import {
  Paper,
  useTheme,
  IconButton,
  Divider,
  Tooltip,
  Stack,
  alpha,
  Popover,
  Box,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
  Menu,
  Slider,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import EditOffIcon from "@mui/icons-material/EditOff";
import EditIcon from "@mui/icons-material/Edit";
import StraightenIcon from "@mui/icons-material/Straighten";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import SubtitlesOffOutlinedIcon from "@mui/icons-material/SubtitlesOffOutlined";
import SubtitlesOutlinedIcon from "@mui/icons-material/SubtitlesOutlined";
import { useReactFlow } from "reactflow";
import {
  TuneOutlined,
  VolumeUp,
  VolumeOff,
  LibraryAddOutlined,
  Visibility,
  ShortText,
  MenuOpen,
  HexagonOutlined,
  AccountTreeOutlined,
  CenterFocusStrongOutlined,
  SwapHorizOutlined,
  DashboardCustomize,
} from "@mui/icons-material";
import AutoLayoutPopover from "../autoLayoutPopover";
import EnlacesPanel from "../enlacesPanel";
import ItensPanel from "../itensPanel";
import { usePersistentOpen } from "../draggableModal";

import { useEffect, useRef, useState } from "react";

import ConfiguracaoMapModal from "../configMapModal";
import { useMapa } from "../../../contexts/mapaContext";
import api from "../../../services/api";
import {
  getLocalMapConfig,
  setLocalMapConfig,
} from "../../../utils/easyMapsLocalConfig";

import usePermissao from "../../../hooks/usePermissao";
const ToolBarMaps = ({
  checkChanges,
  proceedUpdateMode = () => {},
  setOpenAlertModal = () => {},
  setFullScreem,
  fullScreem = false,
  setEditMode,
  editMode = false,
  setLockMode,
  lockMode = false,
  setShowLabel,
  showLabel = true,
  setShowLabelEnlace,
  showLabelEnlace = true,
  setShowRuler,
  showRuler = false,
  children,
  tipo = 0,
  setEasyMapsConfig = () => {},
  easyMapsConfig,
  setRulerPoint,
  collapse = true,
  isPing = false,
  setOpenAddMultiple = () => {},
  showMode = false,
  connectionMode = "selection",
  setConnectionMode,
  hideArea = true,
  setHideArea = () => {},
  onAutoLayout = null,
  onRevertLayout = null,
  hasLayoutHistory = false,
  onSaveLayout = null,
  loadingSaveLayout = false,
  onFocusConnection = null,
}) => {
  const theme = useTheme();
  const { canEdit } = usePermissao("easyMaps");
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElPopover, setAnchorElPopover] = useState(null);
  const [anchorElLayout, setAnchorElLayout] = useState(null);
  const [viewType, setViewType] = useState("compact");
  const [openEnlaces, setOpenEnlaces] = usePersistentOpen(
    "easyMapsEnlacesPanelOpen",
  );
  const [openItens, setOpenItens] = usePersistentOpen("easyMapsItensPanelOpen");
  const [sizes, setSizes] = useState({
    larguraEnlace: 7,
    nodeSize: 1,
    edgeLabelSize: 1,
  });
  const { soundState, setSoundState } = useMapa();

  const abortControllerRef = useRef(null);

  const {
    configurationMap,
    setConfigurationMap,
    setSnackbar,
    updateDataElementSocket,
    mapId,
  } = useMapa();

  const styles = {
    content: {
      padding: "5px",
      position: "absolute",
      zIndex: 1,
      display: "flex",
      flexDirection: "column",
      ml: { xs: "3px", lg: "10px" },
      transition: "margin-left 0.3s ease",
      top: editMode ? { xs: "40px", lg: "10px" } : { xs: "3px", lg: "10px" },
      alignItems: "center",
      gap: 0.5,
      justifyContent: "center",
    },

    card: {
      borderRadius: "6px",
      border: "1px solid " + theme.palette.color.appBarBorder,
      padding: "5px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 0.75,
      backgroundColor: theme.palette.background.default,
      justifyContent: "center",
      zIndex: 10,
    },
    paper: {
      display: "flex",
      flexDirection: "column",
      gap: "2px",
      justifyContent: "center",
      alignItems: "center",
    },
    switch: {
      width: "100%",
      ml: "0px",
      mr: "0px",
    },
    toggleBtn: {
      color: theme.palette.text.disabled,
      border: "none",
      borderRadius: "4px !important",
      textTransform: "none",
      display: "flex",
      flexDirection: "row",
      gap: 0.5,
      alignItems: "end",
      "&.Mui-selected": {
        color: (theme) => theme.palette.primary.main,
        backgroundColor: theme.palette.background.paper,
        "&:hover": {
          backgroundColor: theme.palette.background.card,
        },
      },
    },
    boxBtns: {
      minWidth: 320,
      p: 1.5,
      display: "flex",
      flexDirection: "column",
      background: "none",
    },
  };

  useEffect(() => {
    setViewType(
      configurationMap?.configuracoes?.viewType != null
        ? configurationMap?.configuracoes?.viewType
        : "compact",
    );
    const c = configurationMap?.configuracoes;
    setSizes({
      larguraEnlace: c?.larguraEnlace ?? 7,
      nodeSize: c?.nodeSize ?? 1,
      edgeLabelSize: c?.edgeLabelSize ?? 1,
    });
  }, [configurationMap]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClosePopover = () => {
    setAnchorElPopover(null);
  };
  const handleClickPopover = (event) => {
    setAnchorElPopover((prev) => (prev ? null : event.currentTarget));
  };

  const handleToggleEditMode = (nextEditMode) => {
    if (editMode && !nextEditMode && checkChanges) {
      setOpenAlertModal({
        open: true,
        id: "exit-edit-mode",
        severity: "info",
        buttonText: "Sair sem salvar",
        buttonCancelText: "Continuar editando",
        text: "As alterações feitas não foram salvas. Se você sair do modo de edição, irá perdê-las.",
        callback: () => setEditMode(false),
      });
      return;
    }
    setEditMode(nextEditMode);
  };

  async function handleApiUpdateConfigMap(patch) {
    const data = {
      id: configurationMap?.id,
      data: {
        ...configurationMap,
        mapId,
        configuracoes: {
          ...configurationMap?.configuracoes,
          tipo,
          viewType,
          ...patch,
        },
      },
    };

    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    abortControllerRef.current = new AbortController();

    try {
      const response = await api.put("/easyMaps/map/config/update", data, {
        signal: abortControllerRef.current.signal,
      });

      if (response.data.status === "Error") {
        setSnackbar({
          children:
            "Error: Não foi possível salvar as mudanças as configurações",
          severity: "error",
        });
      } else {
        if (response.data) {
          // config local (salva pelo modal de Ajustes) sobrescreve a do servidor
          // no carregamento; atualiza ela também para a mudança não se perder
          const local = getLocalMapConfig(mapId);
          if (local) setLocalMapConfig(mapId, { ...local, ...patch });
          setConfigurationMap(
            local
              ? {
                  ...response.data,
                  configuracoes: {
                    ...response.data?.configuracoes,
                    ...local,
                    ...patch,
                  },
                }
              : response.data,
          );

          handleClose();
          //  updateDataElementSocket?.();
          setSnackbar({
            children: "Configurações do mapa salvas com sucesso!",
            severity: "success",
          });
        }
      }
    } catch (error) {
      if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
        console.log("Requisição de mudança de visualização cancelada.");
        return;
      }

      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  return (
    <Stack sx={styles.content}>
      <Paper elevation={0} sx={styles.card}>
        {children}

        <IconButtonCustom
          title={fullScreem ? "Sair da Tela Cheia" : "Tela Cheia"}
          iconOn={FullscreenIcon}
          iconOff={FullscreenExitIcon}
          variable={fullScreem}
          onclick={setFullScreem}
        />
        {/* sem setEditMode (link público) não há modo de edição */}
        {setEditMode && canEdit && (
          <IconButtonCustom
            title={
              editMode ? "Desativar modo de ediço" : "Ativar modo de edição"
            }
            iconOn={EditIcon}
            iconOff={EditOffIcon}
            variable={editMode}
            onclick={handleToggleEditMode}
          />
        )}
        {tipo !== 1 && (
          <IconButtonCustom
            title={showLabel ? "Ocultar Detalhes" : "Mostrar detalhes"}
            iconOn={SubtitlesOutlinedIcon}
            iconOff={SubtitlesOffOutlinedIcon}
            variable={showLabel}
            onclick={setShowLabel}
          />
        )}
        {tipo !== 1 && (
          <IconButtonCustom
            title={hideArea ? "Mostrar Áreas" : "Ocultar Áreas"}
            iconOn={HexagonOutlined}
            iconOff={HexagonOutlined}
            variable={hideArea}
            onclick={setHideArea}
          />
        )}
        {setShowRuler && (
          <IconButtonCustom
            title={showRuler ? "Desativar Régua" : "Ativar Régua"}
            iconOn={StraightenIcon}
            iconOff={StraightenIcon}
            variable={showRuler}
            onclick={() => {
              setShowRuler(!showRuler);
              setRulerPoint([]);
            }}
          />
        )}

        {tipo === 1 && (
          <IconButtonCustom
            title={"Visualização"}
            iconOn={Visibility}
            iconOff={Visibility}
            sendEvent={true}
            variable={Boolean(anchorElPopover)}
            onclick={handleClickPopover}
          />
        )}
        {!isPing && (
          <IconButtonCustom
            title={"Enlaces"}
            iconOn={SwapHorizOutlined}
            iconOff={SwapHorizOutlined}
            variable={openEnlaces}
            onclick={() => {
              setOpenEnlaces((prev) => !prev);
            }}
          />
        )}
        <IconButtonCustom
          title={"Itens dos hosts"}
          iconOn={DashboardCustomize}
          iconOff={DashboardCustomize}
          variable={openItens}
          onclick={() => {
            setOpenItens((prev) => !prev);
          }}
        />
        <IconButtonCustom
          title={"Ajustes"}
          iconOn={TuneOutlined}
          iconOff={TuneOutlined}
          variable={Boolean(anchorEl)}
          sendEvent={true}
          onclick={handleClick}
        />
        <IconButtonCustom
          title={
            soundState ? "Desativar sons de alerta" : "Ativar sons de alerta"
          }
          iconOn={VolumeUp}
          iconOff={VolumeOff}
          variable={soundState}
          sendEvent={true}
          onclick={() => {
            setSoundState((prev) => !prev);
          }}
        />
        {editMode && isPing ? (
          <IconButtonCustom
            title={"Adicionar multiplos elementos"}
            iconOn={LibraryAddOutlined}
            iconOff={LibraryAddOutlined}
            variable={false}
            onclick={() => setOpenAddMultiple((prev) => !prev)}
          />
        ) : null}
        {editMode && onAutoLayout && (
          <>
            <Divider sx={{ width: "80%", ml: "10%" }} />
            <IconButtonCustom
              title={"Organizar layout automaticamente"}
              iconOn={AccountTreeOutlined}
              iconOff={AccountTreeOutlined}
              variable={Boolean(anchorElLayout)}
              sendEvent={true}
              onclick={(e) =>
                setAnchorElLayout((prev) => (prev ? null : e.currentTarget))
              }
            />
          </>
        )}
      </Paper>
      {/** Possivel Implementacao para melhorar conexao de linha */}
      {/* {editMode && showMode && (
        <Paper sx={styles.card}>
          <IconButtonCustom
            title="Modo Seleção (Mover nós)"
            iconOn={NearMeOutlined}
            iconOff={NearMeOutlined}
            variable={connectionMode === "selection"}
            onclick={() => setConnectionMode("selection")}
          />
          <Divider sx={{ width: "80%", ml: "10%" }} />
          <IconButtonCustom
            title="Modo Conexão (Criar enlace)"
            iconOn={PolylineOutlined}
            iconOff={PolylineOutlined}
            variable={connectionMode === "connection"}
            onclick={() => setConnectionMode("connection")}
          />
        </Paper>
      )} */}
      {/* <ConfigLocalPopover
        position={fullScreem ? { top: 220, left: 70 } : { top: 280, left: 380 }}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        setEasyMapsConfig={setEasyMapsConfig}
        easyMapsConfig={easyMapsConfig}
      /> */}
      <ConfiguracaoMapModal
        open={Boolean(anchorEl)}
        setOpen={handleClose}
        isPing={isPing}
      />
      <Popover
        open={Boolean(anchorElPopover)}
        anchorEl={anchorElPopover}
        onClose={handleClosePopover}
        disableRestoreFocus
        sx={{ zIndex: 1501 }}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
      >
        <Box sx={styles.boxBtns}>
          <Typography
            fontWeight={500}
            sx={{
              color: theme.palette.text.primary,
              fontSize: "0.875rem",
              textShadow: `0 2px 8px ${alpha(
                theme.palette.primary.main,
                0.08,
              )}`,
            }}
          >
            Visualização
          </Typography>
          <Divider sx={{ borderColor: theme.palette.divider, mb: 1 }} />
          <Stack justifyContent={"center"}>
            <ToggleButtonGroup
              value={viewType}
              exclusive
              onChange={(e, nextView) => {
                if (nextView !== null) {
                  setViewType(nextView);
                  if (canEdit) handleApiUpdateConfigMap(nextView);
                }
              }}
              aria-label="Tipo de visualização"
              size="small"
              sx={{
                backgroundColor: theme.palette.background.paperLinkedMaps,
                padding: 1,
                borderRadius: 2,
                border: "none",
                width: "fit-content",
              }}
            >
              {" "}
              <ToggleButton sx={styles.toggleBtn} value="compact">
                <ShortText />
                Compacto
              </ToggleButton>{" "}
              <Divider
                flexItem
                orientation="vertical"
                sx={{ my: 0.5, mx: 1 }}
              />
              <ToggleButton sx={styles.toggleBtn} value="simple">
                <Menu />
                Simples
              </ToggleButton>
              <Divider
                flexItem
                orientation="vertical"
                sx={{ my: 0.5, mx: 1 }}
              />
              <ToggleButton sx={styles.toggleBtn} value="detailed">
                <MenuOpen />
                Detalhado
              </ToggleButton>
            </ToggleButtonGroup>
          </Stack>
          <Divider sx={{ borderColor: theme.palette.divider, my: 1 }} />
          {[
            { key: "larguraEnlace", label: "Espessura da linha" },
            { key: "nodeSize", label: "Tamanho do elemento" },
            { key: "edgeLabelSize", label: "Tamanho do rótulo da linha" },
          ].map(({ key, label }) => (
            <Box key={key} sx={{ mt: 1.5, px: 1 }}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography
                  sx={{
                    fontSize: "0.72rem",
                    color: theme.palette.text.secondary,
                  }}
                >
                  {label}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.72rem",
                    color: theme.palette.primary.main,
                    fontWeight: 600,
                  }}
                >
                  {sizes[key]}
                </Typography>
              </Stack>
              <Slider
                aria-label={label}
                value={Number(sizes[key])}
                min={1}
                max={50}
                step={1}
                valueLabelDisplay="auto"
                size="small"
                onChange={(e, val) =>
                  setSizes((prev) => ({ ...prev, [key]: val }))
                }
                onChangeCommitted={(e, val) =>
                  handleApiUpdateConfigMap({ [key]: val })
                }
              />
            </Box>
          ))}
        </Box>
      </Popover>
      <AutoLayoutPopover
        anchorEl={anchorElLayout}
        onClose={() => setAnchorElLayout(null)}
        onAutoLayout={onAutoLayout}
        onRevertLayout={onRevertLayout}
        hasLayoutHistory={hasLayoutHistory}
        onSaveLayout={onSaveLayout}
        loadingSaveLayout={loadingSaveLayout}
        editMode={editMode}
      />
      <EnlacesPanel
        open={openEnlaces && !isPing}
        onClose={() => setOpenEnlaces(false)}
        onFocusConnection={onFocusConnection}
      />
      <ItensPanel open={openItens} onClose={() => setOpenItens(false)} />
    </Stack>
  );
};
const IconButtonCustom = ({
  title,
  iconOn: IconOn,
  iconOff: IconOff,
  variable,
  onclick = () => {},
  sendEvent = false,
}) => {
  let theme = useTheme();
  let styles = {
    button: {
      borderRadius: "5px",
      padding: "5px",
      backgroundColor: theme.palette.background.paperSelectedMaps,
      boxShadow: "0px 0px 5px  #00000015",
      "&:hover": { backgroundColor: theme.palette.background.hover },
    },
  };
  return (
    <Tooltip title={title} placement="right">
      <IconButton
        aria-label="custom-icon-button"
        sx={{
          ...styles.button,
          ...(variable
            ? {
                color: theme.palette.primary.main,
              }
            : {}),
        }}
        onClick={(event) => onclick(sendEvent ? event : !variable)}
      >
        <IconOn />
        {/* {!variable ? <IconOn /> : <IconOff sx={styles.icon} />} */}
      </IconButton>
    </Tooltip>
  );
};
const InputZoomTop = () => {
  const { zoomIn, zoomOut, fitView } = useReactFlow();
  const styles = {
    button: {
      borderRadius: "5px",
      padding: "5px",
    },
  };
  return (
    <Stack>
      <IconButtonCustom
        title={"Zoom In"}
        iconOn={AddIcon}
        iconOff={AddIcon}
        variable={false}
        onclick={() => zoomIn()}
      />
      <Divider sx={{ width: "80%", ml: "10%" }} />
      <IconButtonCustom
        title={"Zoom Out"}
        iconOn={RemoveIcon}
        iconOff={RemoveIcon}
        variable={false}
        onclick={() => zoomOut()}
      />
      <Divider sx={{ width: "80%", ml: "10%" }} />
      <IconButtonCustom
        title={"Centralizar"}
        iconOn={CenterFocusStrongOutlined}
        iconOff={CenterFocusStrongOutlined}
        variable={false}
        onclick={() => fitView({ duration: 300 })}
      />
    </Stack>
  );
};
const InputZoomGeo = ({ zoom }) => {
  return (
    <Stack>
      <IconButtonCustom
        title={"Zoom In"}
        iconOn={AddIcon}
        iconOff={AddIcon}
        variable={false}
        onclick={() => zoom(1)}
      />
      <Divider sx={{ width: "80%", ml: "10%" }} />
      <IconButtonCustom
        title={"Zoom Out"}
        iconOn={RemoveIcon}
        iconOff={RemoveIcon}
        variable={false}
        onclick={() => zoom(-1)}
      />
    </Stack>
  );
};
ToolBarMaps.InputZoomGeo = InputZoomGeo;
ToolBarMaps.InputZoomTop = InputZoomTop;
export default ToolBarMaps;
